import { render, staticRenderFns } from "./PricingFormV2.vue?vue&type=template&id=63ca097b&scoped=true&"
import script from "./PricingFormV2.vue?vue&type=script&lang=js&"
export * from "./PricingFormV2.vue?vue&type=script&lang=js&"
import style0 from "./PricingFormV2.vue?vue&type=style&index=0&id=63ca097b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca097b",
  null
  
)

export default component.exports